// extracted by mini-css-extract-plugin
export default {"zoomModal":"q3-z"};